import React, { useState } from "react";
import ActivityLoader from "./ActivityLoader";

const Pagination = ({ metaData, onPageChange, loadMore, loading }) => {
    
  const totalPages = metaData.totalPages || 1;
  const currentPage = metaData.page || 1;
  const pageSize = metaData.pageSize || 0;
  const totalEntries = metaData.total || 0;

  const start = loadMore ? 1 : (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalEntries);

  return (
    <div className="pagination-container d-flex align-items-center justify-content-between">
      <span className="pagination-info">
        <>{end > 0 ? start : 0}</>–{end} of {totalEntries.toLocaleString()}
      </span>
      <div className="pagination-controls">
        {!loadMore && <button
          className="pagination-arrow"
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          <i className="fa fa-angle-left"></i>
        </button>}
        {!loading && <button
          className="pagination-arrow"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          <i className="fa fa-angle-right"></i>
        </button> }
        {loading && <ActivityLoader inline={true} width={13}/>}
      </div>
    </div>
  );
};

export default Pagination;
